import _ from 'lodash';

import * as constants from './FlashCardDetail.constants';
import * as services from './FlashCardDetail.service';

const state = {
  flashCardExerciseType: '',

  modalCardType: '',

  flashCardInfo: {},

  flashCardFilter: [],
  flashCardFilterSwitch: {},

  flashCardList: [],
  idxCard: 0,

  flashCardDetail: {},

  res_answerFlashCard: true,

  isShowAnswer: false,
  isShownAnswerTransition: true,

  isFlashCardReported: false,

  isRequest: false,
  isFilterRequest: false,
  isAnswerRequest: false,
};

const mutations = {
  [constants.SET_CARD_EXERCISE_TYPE](state, flashCardExerciseType) {
    state.flashCardExerciseType = flashCardExerciseType;
  },

  [constants.SET_MODAL_CARD_TYPE](state, modalCardType) {
    state.modalCardType = modalCardType;
  },

  [constants.GET_BOOK_FLASH_CARD_INFO_SUCCESS](state, flashCardInfo) {
    if (undefined !== flashCardInfo && null !== flashCardInfo && flashCardInfo.length > 0) {
      state.flashCardInfo = flashCardInfo[0];
    }
  },

  [constants.GET_BOOK_FLASH_CARD_FILTER_SUCCESS](state, flashCardFilter) {
    if (undefined !== flashCardFilter && null !== flashCardFilter) {
      const { filters, ...flashCardFilterSwitch } = flashCardFilter;
      state.flashCardFilter = _.map(filters, (reading) => ({
        ...reading,
        isRanSeleted: false,
      }));
      state.flashCardFilterSwitch = flashCardFilterSwitch;
    }
  },

  [constants.CHECK_FILTER_READING](state, payload) {
    const { readingId, k } = payload;
    state.flashCardFilter = _.map(state.flashCardFilter, (reading) => {
      if (readingId === reading.readingId) {
        return {
          ...reading,
          [k]: !reading[k],
        };
      } else {
        return reading;
      }
    });
  },

  [constants.TOGGLE_ALL_FILTER_READING](state, payload) {
    const { k, isCheck } = payload;
    state.flashCardFilter = _.map(state.flashCardFilter, (reading) => ({
      ...reading,
      [k]: isCheck,
    }));
  },

  [constants.CHECK_FILTER_REVISE_SWITCH](state, payload) {
    const { k, isCheck } = payload;
    state.flashCardFilterSwitch = {
      ...state.flashCardFilterSwitch,
      [k]: isCheck,
    };
  },

  [constants.SET_BOOK_FLASH_CARD_LIST](state, flashCardList) {
    if (undefined !== flashCardList && null !== flashCardList) {
      state.flashCardList = flashCardList;
    }
  },

  [constants.SET_IDX_CARD](state, idxCard) {
    state.idxCard = idxCard;
  },

  [constants.SET_FLASH_CARD_DETAIL](state, flashCardDetail) {
    if (undefined !== flashCardDetail && null !== flashCardDetail) {
      state.flashCardDetail = flashCardDetail;
    }
  },

  [constants.ANSWER_FLASH_CARD_SUCCESS](state, payload) {
    const { cardDetailId, answer, res_answerFlashCard } = payload;
    state.flashCardList = _.map(state.flashCardList, (card) => {
      if (cardDetailId === card.cardDetailId) {
        return {
          ...card,
          status: answer,
        };
      } else {
        return card;
      }
    });
    state.res_answerFlashCard = res_answerFlashCard;
  },

  [constants.SET_IS_SHOW_ANSWER](state, isShowAnswer) {
    if (!isShowAnswer) {
      state.isShownAnswerTransition = false;
    }
    state.isShowAnswer = isShowAnswer;
    if (!isShowAnswer) {
      setTimeout(() => {
        state.isShownAnswerTransition = true;
      }, 100);
    }
  },

  [constants.SET_IS_FLASH_CARD_REPORTED](state, isFlashCardReported) {
    state.isFlashCardReported = isFlashCardReported;
  },

  [constants.TOGGLE_FAVORITE_FLASH_CARD_SUCCESS](state, favorite) {
    state.flashCardDetail = {
      ...state.flashCardDetail,
      favorite,
    };
  },

  [constants.DUMMY_MUTATION]() {
    //
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.SET_IS_FILTER_REQUEST_STATUS](state, status) {
    state.isFilterRequest = status;
  },

  [constants.SET_IS_ANSWER_REQUEST_STATUS](state, status) {
    state.isAnswerRequest = status;
  },
};

const actions = {
  async getBookFlashCardInfo({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getBookFlashCardInfo(payload);
    commit(constants.GET_BOOK_FLASH_CARD_INFO_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getBookFlashCardFilter({ commit }, payload) {
    commit(constants.SET_IS_FILTER_REQUEST_STATUS, true);
    const res = await services.getBookFlashCardFilter(payload);
    commit(constants.GET_BOOK_FLASH_CARD_FILTER_SUCCESS, res.data.data);
    commit(constants.SET_IS_FILTER_REQUEST_STATUS, false);
  },

  async _getBookFlashCardList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await payload.getBookFlashCardList(payload.payload);
    commit(constants.SET_BOOK_FLASH_CARD_LIST, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  sequenceFlashCardList({ dispatch }, payload) {
    return dispatch('_getBookFlashCardList', {
      payload,
      getBookFlashCardList: services.sequenceFlashCardList,
    });
  },

  randomFlashCardList({ dispatch }, payload) {
    return dispatch('_getBookFlashCardList', {
      payload,
      getBookFlashCardList: services.randomFlashCardList,
    });
  },

  getReviseFlashCardList({ dispatch }, payload) {
    return dispatch('_getBookFlashCardList', {
      payload,
      getBookFlashCardList: services.getReviseFlashCardList,
    });
  },

  getFavoriteFlashCardList({ dispatch }, payload) {
    return dispatch('_getBookFlashCardList', {
      payload,
      getBookFlashCardList: services.getFavoriteFlashCardList,
    });
  },

  async getFavoriteCourseFlashCardList({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getFavoriteCourseFlashCardList(payload);
    const { cssClassName, cardList } = res.data.data;
    commit(constants.GET_BOOK_FLASH_CARD_INFO_SUCCESS, [{ cssClassName }]);
    commit(constants.SET_BOOK_FLASH_CARD_LIST, cardList);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getFlashCardDetail({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getFlashCardDetail(payload);
    commit(constants.SET_FLASH_CARD_DETAIL, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async answerFlashCard({ commit }, payload) {
    commit(constants.SET_IS_ANSWER_REQUEST_STATUS, true);
    const res = await services.answerFlashCard(payload);
    commit(constants.ANSWER_FLASH_CARD_SUCCESS, {
      ...payload,
      res_answerFlashCard: res.data.data,
    });
    commit(constants.SET_IS_ANSWER_REQUEST_STATUS, false);
  },

  async toggleFavoriteFlashCard({ commit }, payload) {
    await services.toggleFavoriteFlashCard(payload);
    commit(constants.TOGGLE_FAVORITE_FLASH_CARD_SUCCESS, payload.favorite);
  },

  async _toggleFlashCardAddQuestion({ commit }, payload) {
    await payload.toggleFlashCardAddQuestion(payload.payload);
    commit(constants.DUMMY_MUTATION);
  },

  toggleFlashCardAddQuestionSequence({ dispatch }, payload) {
    dispatch('_toggleFlashCardAddQuestion', {
      payload,
      toggleFlashCardAddQuestion: services.toggleFlashCardAddQuestionSequence,
    });
  },

  toggleFlashCardAddQuestionRandom({ dispatch }, payload) {
    dispatch('_toggleFlashCardAddQuestion', {
      payload,
      toggleFlashCardAddQuestion: services.toggleFlashCardAddQuestionRandom,
    });
  },

  async flashCardReport({ commit }, payload) {
    await services.flashCardReport(payload);
    commit(constants.DUMMY_MUTATION);
  },
};

const getters = {
  isNoCard: (state) => {
    return 0 === state.flashCardList.length;
  },

  isLastCard: (state) => {
    return state.flashCardList.length - 1 === state.idxCard;
  },

  selectedFlashCardList: (state) => {
    const selectedFlashCardList = state.flashCardList[state.idxCard];
    return selectedFlashCardList ? selectedFlashCardList : {};
  },

  isHaveLastStudy: (state) => {
    return Boolean(state.flashCardInfo.lastStudyCardDetailId);
  },

  lastStudyCardIdx: (state, getters) => {
    if (getters.isHaveLastStudy) {
      return _.findIndex(
        state.flashCardList,
        (card) => state.flashCardInfo.lastStudyCardDetailId === card.cardDetailId
      );
    } else {
      return -1;
    }
  },

  flashCardFilter: (state) => (k) => {
    return _.map(state.flashCardFilter, (reading) => ({
      ...reading,
      isChecked: reading[k],
    }));
  },

  checkedFilterReadings: (state, getters) => (k) => {
    return _.filter(getters.flashCardFilter(k), (reading) => reading.isChecked);
  },

  checkedFilterReadingIds: (state, getters) => (k) => {
    return _.map(getters.checkedFilterReadings(k), (reading) => reading.readingId);
  },

  checkedFilterReadingCardAmount: (state, getters) => (k) => {
    return _.reduce(
      getters.checkedFilterReadings(k),
      (acc, reading) => acc + reading.cardAmount,
      0
    );
  },

  flashCardFilterSwitch: (state) => (k) => {
    return state.flashCardFilterSwitch[k];
  },

  isRequest: (state) => {
    return state.isRequest || state.isFilterRequest || state.isAnswerRequest;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
